export default __webpack_public_path__ + "static/media/Carmina_Burana_Sampler.207a2b1e.mp3";